export const UNIQUE_CONFIG_KEY = 'countryside-serp-frontend';
